class BadgeUpdater {
  constructor() {
    this.updateAllBadges = this.updateAllBadges.bind(this);
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.updateAllBadges);
    } else {
      this.updateAllBadges();
    }
    
    document.addEventListener('shopify:section:load', this.updateAllBadges);
    document.addEventListener('ajax:complete', this.updateAllBadges);
    document.addEventListener('theme:products:updated', this.updateAllBadges);

    this.observeDOMChanges();
  }

  observeDOMChanges() {
    let timeout;
    let lastUpdate = 0;
    const MIN_INTERVAL = 500;
    
    const observer = new MutationObserver((mutations) => {
      const hasBadgeChanges = mutations.some(mutation => {
        return Array.from(mutation.addedNodes).some(node => {
          if (node.nodeType === 1) {
            return node.hasAttribute?.('data-discount-badge') || node.querySelector?.('[data-discount-badge="true"]');
          }
          return false;
        });
      });
      
      if (!hasBadgeChanges) {
        return;
      }
      
      const now = Date.now();
      if (now - lastUpdate < MIN_INTERVAL) {
        return;
      }
      
      console.log('MutationObserver déclenché (badges détectés)', mutations.length, 'mutations');
      clearTimeout(timeout);
      
      timeout = setTimeout(() => {
        console.log('Mise à jour des badges');
        lastUpdate = Date.now();
        this.updateAllBadges();
      }, 150);
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  updateAllBadges() {
    const badges = document.querySelectorAll('[data-discount-badge="true"]');
    
    badges.forEach(badge => {
      const compareAtPrice = parseInt(badge.getAttribute('data-compare-at-price'));
      const salePrice = parseInt(badge.getAttribute('data-sale-price'));
      
      if (window.DiscountCalculator) {
        window.DiscountCalculator.updateBadge(badge, compareAtPrice, salePrice);
      }
    });
  }
}

function initBadgeUpdater() {
  if (window.DiscountCalculator) {
    new BadgeUpdater();
  } else {
    setTimeout(initBadgeUpdater, 100);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBadgeUpdater);
} else {
  initBadgeUpdater();
}
